<div *ngIf="!isResetPassword">
    <div class="page-header border-bottom" *ngIf="(!employeeDetails.IsSystemAdmin && !employeeDetails.IsSecurityAdmin) || employeeDetails.IsCurrentlyLoggedInUser; else updateForUser">
        <h3>Update Your Employee Portal Password</h3>
    </div>
    <ng-template #updateForUser>
        <div class="page-header border-bottom">
            <h3>Update Password for {{ employeeDetails.UserName }}</h3>
        </div>
    </ng-template>
</div>
<div class="container">
    <ng-container *ngIf="isResetPassword">
        <div *ngIf="logoHQCo != null" style="cursor:pointer" (click)="navigateToLogin()">
            <img id="loginLogoImage" [src]="logoUrl" alt="" />
        </div>
        <div class="page-header border-bottom mt-4">
            <h3>Reset Account Password</h3>
        </div>
        <button class="btn btn-primary" type="button" (click)="navigateToLogin()" style="margin-bottom:10px;"><i class="modus-icons align-bottom">chevron_left</i>Back</button>
    </ng-container>
    <div *ngIf="alert" class="alert fade-in" [ngClass]="'alert-' + alert.type" role="alert">{{alert.msg}}</div>
    <div *ngIf="isResetPassword" class="card card-body border bg-light mb-3">
        <div class="row col">
            Please enter your new password below once you have received your&nbsp;<span *ngIf="!employeeParams.ManualToken">verification PIN.</span><span *ngIf="employeeParams.ManualToken">SMS Reset Code</span>
        </div>
    </div>
    <div class="card card-body border bg-light mb-3">
        <div class="row col">
            <i class="modus-icons" style="font-size:1.2em">info</i> Passwords must be at least 12 characters long, and must contain at least 3 of the following: lowercase letters, uppercase letters, numbers, and special characters.
        </div>
    </div>
    <form #changePasswordForm="ngForm" (ngSubmit)="changePassword()" autocomplete="new-password">
        <div class="alert alert-danger" *ngIf="formData.oldPassword == formData.newPassword && formData.oldPassword != null && formData.oldPassword !== ''">Old password cannot be the same as new password.</div>
        <div class="row">
            <div class="col-md-2" *ngIf="!isResetPassword"></div>
            <div [ngClass]="isResetPassword ? 'col-md-12' : 'col-md-6'">
                <ng-container *ngIf="!isResetPassword; else pinOrSmsSection">
                    <div class="form-group" *ngIf="showCurrentPassword()">
                        <label><strong>Current password</strong></label>
                        <app-keypress-events *ngIf="!isIE"
                                             [required]="true"
                                             [(ngModel)]="formData.oldPassword"
                                             placeHolder="Current password"
                                             name="currentPassword">
                        </app-keypress-events>
                        <input *ngIf="isIE > 0"
                               type="password"
                               class="form-control"
                               name="currentPassword"
                               id="current"
                               [(ngModel)]="formData.oldPassword"
                               placeholder="Current password"
                               required
                               autocomplete="new-password" />
                    </div>
                </ng-container>
                <ng-template #pinOrSmsSection>
                    <div class="form-group" *ngIf="employeeParams.ManualToken">
                        <label><strong>SMS Reset Code</strong></label>
                        <app-keypress-events *ngIf="!isIE"
                                             [required]="true"
                                             [(ngModel)]="formData.verificationPIN"
                                             placeHolder="SMS Reset Code"
                                             name="code">
                        </app-keypress-events>
                        <input *ngIf="isIE > 0"
                               type="password"
                               class="form-control"
                               [(ngModel)]="formData.verificationPIN"
                               required
                               name="code"
                               placeholder="SMS Reset Code"
                               autocomplete="new-password" />
                    </div>
                    <div class="form-group" *ngIf="!employeeParams.ManualToken">
                        <label><strong>{{securityPinMessage ?? 'Security PIN'}}</strong></label>
                        <app-keypress-events *ngIf="!isIE"
                                             [required]="true"
                                             [(ngModel)]="formData.securityPIN"
                                             placeHolder="PIN"
                                             name="pin">
                        </app-keypress-events>
                        <input *ngIf="isIE > 0"
                               type="password"
                               class="form-control"
                               [(ngModel)]="formData.securityPIN"
                               required
                               name="pin"
                               placeholder="{{securityPinMessage}}"
                               autocomplete="new-password" />
                    </div>
                </ng-template>
                <div class="form-group">
                    <label><strong>New password</strong></label>
                    <app-keypress-events *ngIf="!isIE"
                                         [required]="true"
                                         [(ngModel)]="formData.newPassword"
                                         placeHolder="Current password"
                                         (blur)="confirmPassword()"
                                         (change)="clearErrors()"
                                         name="newPassword">
                    </app-keypress-events>
                    <input *ngIf="isIE > 0"
                           type="password"
                           class="form-control"
                           id="new"
                           name="newPassword"
                           [(ngModel)]="formData.newPassword"
                           (change)="clearErrors()"
                           (blur)="confirmPassword()"
                           placeholder="New password"
                           required
                           autocomplete="new-password" />
                </div>
                <div class="form-group inner-addon right-addon">
                    <i class="modus-icons" style="color: red; z-index: 5; margin-top: 27px;font-size:1.3em" *ngIf="!passwordsMatch">close</i>
                    <label><strong>Confirm new password</strong></label>
                    <app-keypress-events *ngIf="!isIE"
                                         [required]="true"
                                         [(ngModel)]="formData.confirmPassword"
                                         placeHolder="Current password"
                                         (blur)="confirmPassword()"
                                         (change)="clearErrors()"
                                         name="confirmNewPassword">
                    </app-keypress-events>
                    <input *ngIf="isIE > 0"
                           type="password"
                           class="form-control"
                           id="confirm"
                           name="confirmNewPassword"
                           [(ngModel)]="formData.confirmPassword"
                           (blur)="confirmPassword()"
                           (change)="clearErrors()"
                           placeholder="Confirm new password"
                           required
                           autocomplete="new-password" />
                </div>
                <button type="submit" class="btn btn-primary" [disabled]="!passwordsMatch || changePasswordForm.invalid || (!isResetPassword && formData.oldPassword == formData.newPassword && formData.oldPassword != null)">Submit</button>
            </div>
        </div>
    </form>
</div>

